import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminWorkflowInspector = lazy(() => import("@/pages/admin/AdminWorkflowInspector"));

export const Route = createFileRoute("/admin/workflow-inspector")({
  component: AdminWorkflowInspector,
});
